@if(request) {

  @if (request.rejectReason && asAdmin) {
    <div>
      <span class="text-danger"><fa-icon icon="times"></fa-icon> Raison du refus @if (request.partial) {
      partiel
    } :</span>
    <p>
      {{ request.rejectReason }}
    </p>
  </div>
}

@if (countProductsDiffs(); as c) {
  <div>
    <p class="fw-bold mb-1">Modification{{ c > 1 ? 's' : '' }} demandée{{ c > 1 ? 's' : '' }} sur les logiciels</p>
    <ul class="list-unstyled">
      @for (p of request.products | keyvalue; track p) {
        <li>
          @if (!p.value.toAdd) {
            <fa-icon class="text-info" icon="arrow-right"></fa-icon>
            Dissociation du logiciel
            @if (getFaqCategoryByName(p.key); as cat) {
              <app-badge
                [label]="{id: 0, textcolor: cat.textcolor, backcolor: cat.backcolor, name: cat.name}"
              class="me-1 ms-1"></app-badge>
            } @else {
              <app-badge [label]="{id: 0, textcolor: '#ffffff', backcolor: '#6c757d', name: p.key}" class="me-1 ms-1"></app-badge>
            }
          }
        </li>
      }
      @for (p of request.products | keyvalue; track p) {
        <li>
          @if (p.value.toAdd) {
            <fa-icon class="text-info" icon="arrow-right"></fa-icon>
            Ajout du logiciel
            @if (getFaqCategoryByName(p.key); as cat) {
              <app-badge
                [label]="{id: 0, textcolor: cat.textcolor, backcolor: cat.backcolor, name: cat.name}"
              class="me-1 ms-1"></app-badge>
            } @else {
              <app-badge [label]="{id: 0, textcolor: '#ffffff', backcolor: '#6c757d', name: p.key}" class="me-1 ms-1"></app-badge>
            }
          }
        </li>
      }
    </ul>
  </div>
}
@if (isProfileDifferent()) {
  <div>
    <p class="fw-bold mb-1">Modification demandée sur le profil</p>
    <ul class="list-unstyled">
      <li>
        <fa-icon class="text-info" icon="arrow-right"></fa-icon>
        @if (request.profile.profile === 'Simple') {
          <span>
            Passage au statut d'utilisateur simple
            <p
              class="small ps-3"><em>Actuellement l'utilisateur est utilisateur {{ user.referent ? 'référent Portail' : 'Simple' }}</em></p>
            </span>
          } @else {
            <span>
              Passage au statut d'utilisateur référent Portail
              <p
                class="small ps-3"><em>Actuellement l'utilisateur est utilisateur {{ user.referent ? 'référent Portail' : 'Simple' }}</em></p>
              </span>
            }
          </li>
        </ul>
      </div>
    }
    @if (countCoordsDiffs(); as c) {
      <div>
        <p class="fw-bold mb-1">Modification{{ c > 1 ? 's' : '' }} demandée{{ c > 1 ? 's' : '' }} sur les coordonnées</p>
        <ul class="list-unstyled">
          @if (request.coords.firstname != null) {
            <li>
              <fa-icon class="text-info" icon="arrow-right"/>
              Changement de prénom :
              @if (asAdmin) {
                <span class="text-primary cursor-pointer icon-hover" ngbTooltip="Copier" appCopy="Prénom">
                  {{ request.coords.firstname }}
                  <fa-icon icon="copy"/>
                </span>
              }
              @if (!asAdmin) {
                <span>{{ request.coords.firstname }}</span>
              }
              <p class="small ps-3"><em>Actuellement le prénom est : {{ user.firstname }}</em></p>
            </li>
          }
          @if (request.coords.lastname != null) {
            <li>
              <fa-icon class="text-info" icon="arrow-right"></fa-icon>
              Changement de nom :
              @if (asAdmin) {
                <span class="text-primary cursor-pointer icon-hover" ngbTooltip="Copier" appCopy="Nom">
                  {{ request.coords.lastname }}
                  <fa-icon icon="copy"/>
                </span>
              }
              @if (!asAdmin) {
                <span>{{ request.coords.lastname }}</span>
              }
              <p class="small ps-3"><em>Actuellement le nom est : {{ user.lastname }}</em></p>
            </li>
          }
          @if (request.coords.email != null) {
            <li>
              <fa-icon class="text-info" icon="arrow-right"></fa-icon>
              Changement d'adresse mail :
              @if (asAdmin) {
                <span class="text-primary cursor-pointer icon-hover" ngbTooltip="Copier" appCopy="Mail">
                  {{ request.coords.email }}
                  <fa-icon icon="copy"/>
                </span>
              }
              @if (!asAdmin) {
                <span>{{ request.coords.email }}</span>
              }
              <p class="small ps-3"><em>Actuellement l'adresse mail est : {{ user.email }}</em></p>
            </li>
          }
          @if (request.coords.phone != null) {
            <li>
              <fa-icon class="text-info" icon="arrow-right"></fa-icon>
              Changement de numéro de téléphone :
              @if (asAdmin) {
                <span class="text-primary cursor-pointer icon-hover" ngbTooltip="Copier" appCopy="Numéro">
                  {{ request.coords.phone }}
                  <fa-icon icon="copy"/>
                </span>
              }
              @if (!asAdmin) {
                <span>{{ request.coords.phone }}</span>
              }
              <p class="small ps-3"><em>Actuellement le numéro de téléphone est : {{ user.phone }}</em></p>
            </li>
          }
        </ul>
      </div>
    }

  }
